<template>
    <ns-modal
        v-model="dialog"
        :fullscreen="fullScreen"
        :title="txc.edit_email"
        @input="closeDialog"
    >
        <server-error v-if="!!dialogError" :error="dialogError" />
        <v-form ref="marketingEmailForm" v-model="emailAddressForm" @submit.prevent>
            <div class="modal-desc">{{txc.email_desc}}</div>
            <section>
                <div class="field-label">{{txc.current_email}}</div>
                <div class="field-value">{{email}}</div>
            </section>
            <NsEmailSimple
                v-model="emailAddress"
                :label="txc.new_email"
                required
                :duped-email-text="sharedStrings.forms.fieldBadEmail"
                :required-error-message="sharedStrings.forms.fieldRequired"
                :invalid-email-text="sharedStrings.forms.fieldBadEmail"
                data-testid="email"
                maxlength
                autofocus
                @input="emailInput"
                :check-email="checkEmail"
            />
        </v-form>
        <template v-slot:actions>
            <v-layout column>
                <v-flex xs12>
                    <button
                        flat
                        block
                        class="primary-hit mb-2 fluid"
                        :disabled="buttonDisabled"
                        @click="editEmail()"
                    >{{sharedStrings.generic.save}}</button>
                </v-flex>
                <v-spacer/>
                <v-flex xs12>
                    <button
                        flat
                        outline
                        block
                        class="secondary-hit fluid"
                        @click="closeDialog"
                    >{{sharedStrings.generic.cancel}}</button>
                </v-flex>
            </v-layout>
        </template>
    </ns-modal>
</template>

<script>
import * as ruleSet from '../../repositories/globalRules.js';
import { ProfileService, EmailService } from '@nuskin/ns-account';
import { mapGetters, mapActions } from 'vuex';
import { NsModal, NsEmailSimple } from '@nuskin/design-components';
import ServerError from '../ServerError';
import profileUtils from '../../repositories/profileUtils';

export default {
    components: {
        NsModal,
        NsEmailSimple,
        ServerError
    },
    data() {
        return {
            ruleSet,
            dialog: true,
            dialogError: null,
            emailAddress: '',
            emailAddressForm: {},
            buttonDisabled: true,
            // eslint-disable-next-line security/detect-unsafe-regex, max-len
            emailPattern: /^[\s]*[A-Za-z0-9!#$%&*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?[\s]*$/
        };
    },
    props: {
        isLegacy: Boolean
    },
    computed: {
        ...mapGetters({
            txc: 'translationsCommunication',
            sharedStrings: 'sharedStrings',
            email: 'email',
            fullScreen: 'mobileView',
            account: 'account'
        })
    },
    methods: {
        ...mapActions(['setAccount']),
        closeDialog() {
            this.$emit('closeDialog');
            this.dialogError = null;
        },
        emailInput(inputValue) {
            if (!this.emailPattern.test(inputValue)) {
                this.buttonDisabled = true
            }
        },
        async checkEmail() {
            let [isFormatValid, isDomainValid, isAvailable, isServiceValid] = [true, true, true, true];
            if(this.isLegacy) {
                isServiceValid = await EmailService.validateEmailUsingService(this.emailAddress)
            } else {
                [
                    isFormatValid,
                    isDomainValid,
                    isAvailable
                ] = await profileUtils.isDuplicateEmail(
                    encodeURIComponent(this.emailAddress),
                );
                isServiceValid = Boolean(isFormatValid && isDomainValid);
            }

            if (isServiceValid && isAvailable) {
                this.buttonDisabled = false
            } else {
                this.buttonDisabled = true
            }
            
            return [isServiceValid, isAvailable];
        },
        editEmail() {
            let self = this;
            let emailAddress = { email: this.emailAddress };
            ProfileService.updateAccountInfo(emailAddress)
                .then(function(response) {
                    if (response && response.data && response.data.account) {
                        const email = self.account.email;
                        self.setAccount(response.data.account);
                        self.closeDialog();
                        profileUtils.publishAnalytics(
                            self.$analytics.category.communications,
                            'marketing_email_address',
                            'updated', {email , locale: self.account.preferredLanguage, useEmailId: true}
                        );
                    }
                })
                .catch(error => {
                    this.dialogError = error;
                });
        }
    },
    created() {
        profileUtils.publishAnalytics(
            this.$analytics.category.communications,
            'marketing_email_address_dialog',
            'opened'
        );
    },
    destroyed() {
        profileUtils.publishAnalytics(
            this.$analytics.category.communications,
            'marketing_email_address_dialog',
            'closed'
        );
    }
};
</script>

<style scoped lang="scss">
@use "sass:map";
@use '~@nuskin/ns-core-styles/src/scss/global.mixins';
.modal-desc {
    @include global.p-small();
    margin-bottom: 16px;
}
</style>
